/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowCmdbConfigView extends models.ServiceNowCmdbConfigBaseResponse {
    getFixupPrototypeFunction() { return ServiceNowCmdbConfigView.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowCmdbConfigView>): ServiceNowCmdbConfigView {
        let obj = Object.assign(new ServiceNowCmdbConfigView(), model);
        ServiceNowCmdbConfigView.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowCmdbConfigView>): ServiceNowCmdbConfigView {
        if (!model) return null;
        return ServiceNowCmdbConfigView.newInstance(<ServiceNowCmdbConfigView> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowCmdbConfigView) {
        if (!obj) return;

        models.ServiceNowCmdbConfigView.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowCmdbConfigView): boolean {
        if (models.ServiceNowCmdbConfigBaseResponse.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceNowCmdbConfigView.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.configuration) {
            for (let key in this.configuration) {
                let val = this.configuration[key];
                if (val) {
                    models.ServiceNowCmdbServiceConfig.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Id of the ServiceNow Account
     */
    cmdb_account_id: string;

    /**
     * Name of the Cmdb Service
     */
    cmdb_service: string;

    /**
     * ServiceNow Cmdb Sync Configuration, indexed by CloudServiceName
     */
    configuration: { [key: string]: models.ServiceNowCmdbServiceConfig; };

}
